import { makeSimulationAPICall } from '@exodus/web3-utils';
import { BLOWFISH_EVM_CHAINS } from './common.js';
const convertToAPIPayload = ({ origin, address, message, }) => {
    const restParameters = {
        metadata: { origin },
        userAccount: address,
    };
    if (message.messageType === 1 /* MessageTypeEnum.TypedData */) {
        const kind = 'SIGN_TYPED_DATA';
        return {
            message: {
                kind,
                data: JSON.parse(message.message),
            },
            ...restParameters,
        };
    }
    const kind = 'SIGN_MESSAGE';
    return {
        message: {
            kind,
            rawMessage: message.message,
        },
        ...restParameters,
    };
};
export const handleActionResponse = ({ simulationResult, response, }) => {
    if (['BLOCK', 'WARN'].includes(response.action)) {
        simulationResult.action = response.action;
    }
};
export const simulateMessage = async ({ address, apiEndpoint, message, origin, headers, simulationResult, }) => {
    const { network, chain } = BLOWFISH_EVM_CHAINS[simulationResult.baseAssetName];
    const payload = convertToAPIPayload({ address, origin, message });
    const response = await makeSimulationAPICall({
        url: apiEndpoint,
        chain,
        network,
        payload,
        headers,
    });
    if (!response) {
        return;
    }
    handleActionResponse({ simulationResult, response });
};
